import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=740f2069&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f2069",
  null
  
)

export default component.exports